import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {downloadApk, stopBeforeDownload} from '@utils';

const logo = require('@assets/imgs/home/home_logo.webp');
const downloadButton = require('@assets/imgs/home/download.webp');
const closeIcon = require('@components/assets/icons/close_header.webp');

export default function DownloadGe() {
  const {t} = useTranslation();
  const [isHidden, setIsHidden] = useState(false);

  const toDownload = useCallback(() => {
    if (stopBeforeDownload()) {
      return;
    }
    downloadApk();
  }, []);

  const closeBanner = useCallback(
    (event: React.SyntheticEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setIsHidden(true);
    },
    [],
  );

  if (isHidden) {
    return null;
  }

  return (
    <section
      aria-label={t('home.downloadBanner.title')}
      className="flex h-[3.5rem] w-full items-center justify-between bg-gradient-to-r from-[#0e82a2] to-[#00492e] px-3 py-1">
      <div className="flex min-w-0 max-w-[12.5rem] flex-1 items-center gap-2">
        <img
          alt=""
          aria-hidden="true"
          className="h-10 w-10 shrink-0 rounded-[0.3125rem] bg-black object-contain"
          src={logo}
        />
        <div className="flex min-w-0 flex-1 flex-col items-start justify-center gap-0.5 whitespace-nowrap text-white tracking-[-0.01875rem]">
          <strong className="max-w-full truncate text-sm font-bold uppercase leading-normal">
            {t('home.downloadBanner.title')}
          </strong>
          <span className="max-w-full truncate text-xs font-medium leading-normal opacity-70">
            {t('home.downloadBanner.subtitle')}
          </span>
        </div>
      </div>

      <div className="flex shrink-0 items-center justify-end gap-3">
        <button
          type="button"
          aria-label={t('home.downloadBanner.download')}
          className="h-9 w-[6.5rem] shrink-0 overflow-hidden rounded-full border-0 bg-transparent p-0"
          onClick={toDownload}>
          <img
            alt=""
            aria-hidden="true"
            className="block h-full w-full object-contain"
            src={downloadButton}
          />
        </button>
        <button
          type="button"
          aria-label={t('home.downloadBanner.close')}
          className="relative flex h-[1.125rem] w-[1.125rem] shrink-0 items-center justify-center border-0 bg-transparent p-0 after:absolute after:-inset-2 after:content-['']"
          onClick={closeBanner}>
          <img
            alt=""
            aria-hidden="true"
            className="h-[1.125rem] w-[1.125rem] opacity-50"
            src={closeIcon}
          />
        </button>
      </div>
    </section>
  );
}
